import React from "react";
import {Row as BootStrapRow} from "react-bootstrap";

type Props = {
  children: React.ReactNode;

  id?: string;
  style?: React.CSSProperties;
  className?: string;
};

const Row = (props: Props) => {
  return (
    <BootStrapRow id={props.id} className={props.className} style={props.style}>
      {props.children}
    </BootStrapRow>
  );
};

export default Row;
